module.exports = __webpack_public_path__ + "static/img/faq-hover.c5cb3d6.svg";


//////////////////
// WEBPACK FOOTER
// ./static/prism_admin/images/faq-hover.svg
// module id = hZJc
// module chunks = 68